import { render, staticRenderFns } from "./filtered_search_suggestion_list.vue?vue&type=template&id=6f8dabac"
import script from "./filtered_search_suggestion_list.vue?vue&type=script&lang=js"
export * from "./filtered_search_suggestion_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports